import React from 'react';
import PropTypes from 'prop-types';
import { compose, onlyUpdateForKeys } from 'recompose';

import pure from '../../lib/pure';
import withWorkType from '../../containers/withWorkType';
import { WorkTypeRecord } from '../../entities/records';

function WorkTypeName({ workType }) {
  if (!workType) {
    return null;
  }

  return <span>{workType.name}</span>;
}

WorkTypeName.defaultProps = {
  workType: null,
};

WorkTypeName.propTypes = {
  workType: PropTypes.instanceOf(WorkTypeRecord),
};

export default compose(
  pure,
  withWorkType,
  onlyUpdateForKeys(['workTypeId']),
)(WorkTypeName);
